import React from 'react';
import { createRoot } from 'react-dom/client';

import ConfirmModal, {
    ConfirmModalTypes,
} from '../components/modals/confirmModal';

const confirm = (
    message: string,
    type?: ConfirmModalTypes,
    description?: string,
    abort?: string,
    confirm?: string,
    showAbort?: boolean,
    showWarningButton?: boolean,
    showOutlinedButton?: boolean,
) => {
    const container = document.getElementById('modal-root');
    const root = createRoot(container!);
    return new Promise((res) => {
        const getUserConfirmation = (isConfirmed: boolean) => {
            root.unmount();
            res(isConfirmed);
        };

        root.render(
            <ConfirmModal
                type={type}
                message={message}
                getUserConfirmation={getUserConfirmation}
                description={description}
                abort={abort}
                confirm={confirm}
                showAbort={showAbort}
                showWarningButton={showWarningButton}
                showOutlinedButton={showOutlinedButton}
                className="drawer-click-exempt"
            />,
        );
    });
};
// TODO: replace with confirmDialog
export default confirm;
